<template>
  <page-container
    title="Appointment request submitted!"
    :narrow="false"
    :hide-footer="true"
  >
    <template #content>
      <pp-container
        class="pa-6"
      >
        <pp-row>
          <pp-col
            cols="12"
            :sm="12"
          >
            <div class="d-flex align-center text-h2 mb-5">
              <i class="pp-icon-check-circle success--text d-none d-sm-inline-flex pr-2" />
              You're all set!
            </div>
          </pp-col>

          <pp-col
            v-if="inPersonAppointment"
            cols="12"
            :sm="12"
          >
            <pp-map
              v-if="showMap"
              ref="addressMap"
              :address="address"
              type="embed"
              data-cy-id="appointment-address"
              :api-key="mapKey"
              @map-error="onMapError"
            />
            <div
              v-else
            >
              <pp-avatar-info
                :address="calendar.displayInfo.address"
                :image="calendar.displayInfo.image"
                :name="calendar.displayInfo.name"
                :specialty="calendar.displayInfo.specialty"
                size="xxl"
                :virtual-visit="false"
                class="py-0 py-sm-3"
              />
            </div>
          </pp-col>
        </pp-row>
      </pp-container>
    </template>
  </page-container>
</template>
<script>
import Vuex from 'vuex'
import Calendar from '@/entities/Calendar'
import PageContainer from '@/components/page-container/PageContainer'
import * as uiTypes from '@/store/ui/mutations-types'
import { datadogRum } from '@datadog/browser-rum'
import {
  VISIT_TYPE_IN_PERSON_VALUE
} from '@/views/constants'

const { mapState, mapGetters } = Vuex

export default {
  name: 'ViewsConfirmation',
  components: {
    'page-container': PageContainer
  },
  data: function () {
    return {
      mapLoadedWithAnError: false
    }
  },
  computed: {
    ...mapState('legacy', ['createdAppointment', 'calendars']),
    ...mapGetters({
      formData: 'formData/formData',
      googleMapsApiKey: 'legacy/googleMapsApiKey',
      filledSteps: 'ui/filledSteps'
    }),
    calendar () {
      return this.calendars[this.formData.calendarIndex] || new Calendar()
    },
    address () {
      const appointmentLocation = this.calendar.displayInfo.displayLocations.list.find(l => l.id === this.formData.locationId)
      return appointmentLocation ? appointmentLocation.addressLine : ', ,'
    },
    inPersonAppointment () {
      return this.formData.isTelehealth === VISIT_TYPE_IN_PERSON_VALUE
    },
    showMap () {
      return !this.mapLoadedWithAnError && (this.googleMapsApiKey || this.$urlBasedFrame)
    },
    mapKey () {
      return this.googleMapsApiKey || undefined
    }
  },
  created () {
    if (!this.filledSteps.stepC) {
      datadogRum.addAction('confirmation step opened by directUrl', {
        message: 'confirmation step opened, but prev step(s) was not filled',
        formData: {
          newPatient: this.formData.newPatient,
          isTelehealth: this.formData.isTelehealth,
          reason: this.formData.reason,
          insuranceProviderId: this.formData.insuranceProviderId,
          doctorId: this.formData.doctorId,
          locationId: this.formData.locationId,
          timeBlock: this.formData.timeBlock,
          calendarIndex: this.formData.calendarIndex,
          calendarId: this.formData.calendarId,
          scheduleId: this.formData.scheduleId,
          calendarBlockId: this.formData.calendarBlockId
        },
        practice: {
          id: this.$practiceId,
          step: 'Confirmation'
        },
        redirectedTo: 'stepA'
      })
      this.$router.replace({ name: 'stepA', query: this.$route.query || {} })
    }
    this.$store.commit(`ui/${uiTypes.RESET_STEPS_FILLING}`)
  },
  methods: {
    onMapError () {
      this.mapLoadedWithAnError = true
    }
  }
}
</script>

<style lang="scss" scoped>
.complete-registration-btn {
  ::v-deep {
    .v-btn {
      height: auto;
    }
  }
}

.confirmed-request-text {
  font-size: calc-rem(12px);
  letter-spacing: .02em;
  line-height: calc-rem(16px);
  max-width: 276px;
  text-align: center;
}
</style>
